<script context="module">
    import { encode } from 'js-base64';

    import { fetchInitOffer, fetchOffer } from './clients/OfferClient.svelte';
    import { fetchPromos } from './clients/PromosClient.svelte';
    import { principalStreamersNames } from './Environment.svelte';

    export function fetchOfferIfNotLoaded(store, store_offer, callback) {
        if (store_offer.loadedOffer.offers == null) {
            fetchOffer(
                store.requestedAddress.postalCode,
                store.requestedAddress.addressId,
                store.requestedAddress.offnetCoverage
            ).then(callback);
        }
    }

    export function getInitOffer(store_init_offer, callback) {
        if (store_init_offer.loadedOffer.offers == null) {
            fetchInitOffer().then(callback);
        }
    }

    export function getPromos(productsBody, callback) {
        fetchPromos(productsBody).then(callback);
    }

    export function getExtras(store, store_offer) {
        let channelExtras = store.requestedServices.channelExtras.map(
            (extra) => {
                return {
                    extId: extra.extId,
                    title: extra.extra.title,
                    nuevaCantidad: extra.nuevaCantidad,
                    combo: extra.combo ? extra.combo : false,
                };
            }
        );
        let tvExtensions = store.requestedServices.tvExtensionsExtras.map(
            (extra) => {
                return {
                    extId: extra.extId,
                    title: extra.extra.title,
                    nuevaCantidad: extra.nuevaCantidad,
                    combo: extra.combo ? extra.combo : false,
                };
            }
        );
        let movilExtras = Object.values(
            store.requestedServices.izzimovil.reduce((acc, movil) => {
                const extId = movil.plan.paqId
                    ? movil.plan.paqId
                    : movil.plan.extId;
                if (acc[extId]) {
                    acc[extId].nuevaCantidad += 1;
                } else {
                    acc[extId] = {
                        extId,
                        nuevaCantidad: 1,
                        combo: true,
                    };
                }
                return acc;
            }, {})
        );
        return {
            latitude: store.requestedAddress.latitude,
            longitude: store.requestedAddress.longitude,
            rpt: store.requestedAddress.addressRPT,
            coverageType: store_offer.loadedOffer.coverageType,
            offnet:
                (store.requestedAddress.offnetIzziCoverage &&
                    store.requestedAddress.offnetCoverage) ||
                store.requestedServices.isSky,
            requestedServices: {
                product: store.requestedServices.productId,
                extras: [...channelExtras, ...tvExtensions, ...movilExtras],
            },
        };
    }

    export function getProductFromProductId(offers, receivedProduct) {
        var productToReturn = null;
        if (receivedProduct.productFamily) {
            let products = offers[receivedProduct.productFamily];
            if (products != null) {
                products.forEach((product) => {
                    if (
                        product.paqId == parseInt(receivedProduct.productId) &&
                        product.visible
                    ) {
                        productToReturn = product;
                        productToReturn['productFamily'] =
                            receivedProduct.productFamily;
                        return;
                    }
                });
                if (productToReturn == null) {
                    products.forEach((product) => {
                        if (product.vel == receivedProduct.productSpeed) {
                            productToReturn = product;
                            productToReturn['productFamily'] =
                                receivedProduct.productFamily;
                            return;
                        }
                    });
                }
            }
        }
        return productToReturn;
    }

    export function getFullName(personalDetails) {
        let fullName = [];
        if (personalDetails.nombre != '') {
            fullName.push(personalDetails.nombre);
        }
        if (personalDetails.segundoNombre != '') {
            fullName.push(personalDetails.segundoNombre);
        }
        if (personalDetails.apPaterno != '') {
            fullName.push(personalDetails.apPaterno);
        }
        if (personalDetails.apMaterno != '') {
            fullName.push(personalDetails.apMaterno);
        }
        return fullName.join(' ');
    }

    export function getIzziMovilFamilyTranslation(plan) {
        if (plan.promotionPrice == null) {
            if (plan.family == 'Negocios') {
                return 'Planes de negocio';
            } else {
                return 'Planes personales';
            }
        } else {
            return 'Planes con promoción';
        }
    }

    export const imeiIsValid = (imei) => {
        return /^\d{15}$/.test(imei);
    };

    export function getExtMessage(extName, extMessages) {
        return extMessages[extName] || '';
    }

    export function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result
                    .toString()
                    .replace(/^data:(.*,)?/, '');
                if (encoded.length % 4 > 0) {
                    encoded += '='.repeat(4 - (encoded.length % 4));
                }
                resolve(encoded);
            };
            reader.onerror = (error) => reject(error);
        });
    }

    export function getToken(
        postalCode,
        offnetCoverage,
        isSky,
        addressString,
        addressId,
        product,
        addressRPT,
        calle,
        colonia,
        delegacion,
        estado,
        numero,
        interior,
        latitud,
        longitud
    ) {
        if (addressId != undefined) {
            return encode(
                JSON.stringify({
                    addressId: addressId,
                    postalCode: postalCode,
                    productId: product.productId,
                    productFamily: product.productFamily,
                    productSpeed: product.productSpeed,
                    addressString: addressString,
                    addressRPT: addressRPT,
                    calle: calle,
                    colonia: colonia,
                    delegacion: delegacion,
                    estado: estado,
                    numero: numero,
                    interior: interior,
                    latitud: latitud,
                    longitud: longitud,
                    isSky: isSky,
                })
            );
        } else {
            return encode(
                JSON.stringify({
                    postalCode: postalCode,
                    offnetCoverage: offnetCoverage,
                    isSky: isSky,
                })
            );
        }
    }

    export function isTelephony(productFamily) {
        if (
            productFamily == null ||
            productFamily == 'tv' ||
            productFamily == 'internet' ||
            productFamily == 'izzinegocios_tv' ||
            productFamily == 'izzinegocios_internet'
        ) {
            return false;
        }
        return true;
    }

    export function isNegocios(productFamily) {
        if (
            productFamily != null &&
            productFamily.indexOf('izzinegocios') > -1
        ) {
            return true;
        }
        return false;
    }

    export function isCombo(extra, store, lugar) {
        return (
            (principalStreamersNames
                .slice(1, 3)
                .includes(extra.extra.extName) &&
                store.requestedServices.isNetflix) ||
            (extra.extra.extName === principalStreamersNames.at(5) &&
                store.requestedServices.isNetflix) ||
            (extra.extra.extName === principalStreamersNames.at(6) &&
                store.requestedServices.isNetflix) ||
            (extra.extra.extName === principalStreamersNames.at(0) &&
                store.requestedServices.isVix) ||
            ((extra.extra.extName === principalStreamersNames.at(4) ||
                extra.extra.extName === principalStreamersNames.at(7)) &&
                store.requestedServices.isHBO) ||
            (extra.extra.extName === principalStreamersNames.at(8) &&
                store.requestedServices.isHBOAdds)
        );
    }

    export function addItem(itemTemp, store) {
        let selectedExtras = store.requestedServices.channelExtras;
        let omitir =
            store.requestedServices.product.productFamily === 'residencial' &&
            store.requestedServices.product.vel < 100;
        if (
            selectedExtras.find((e) => {
                return e.extId === itemTemp.extId;
            }) == undefined
        ) {
            selectedExtras.push({
                extId: itemTemp.extId,
                nuevaCantidad: 1,
                extra: {
                    title: itemTemp.extra.title,
                    cost:
                        itemTemp.extra.extName ===
                            principalStreamersNames.at(0) &&
                        !store.requestedServices.isVix &&
                        itemTemp.extra.promoItem != null &&
                        itemTemp.extra.promoItem.precio != null
                            ? itemTemp.extra.promoItem.precio
                            : itemTemp.extra.cost,
                    extGrupo: itemTemp.extra.extGrupo,
                    extName: itemTemp.extra.extName,
                    opcionesModular: omitir
                        ? new Array()
                        : itemTemp.extra.opcionesModular,
                    descriptionOTT: itemTemp.extra.descriptionOTT,
                },
                combo: isCombo(itemTemp, store, 'addItem'),
            });
        }
        store.requestedServices.channelExtras = selectedExtras.filter((extra) =>
            removeInvalidExtras(extra, itemTemp)
        );
    }

    export const findExtra = (ottName, plan) => {
        return plan.extrasMap.ott.find(
            (extra) => extra.extra.extName == ottName
        );
    };

    export const findExtraByName = (extraName, plan) => {
        return plan.extrasMap.ott.find(
            (extra) => extra.extra.extName === extraName
        );
    };

    function removeInvalidExtras(extra, itemTemp) {
        let invalid = false;
        if (itemTemp.extra.extEliminar != null) {
            itemTemp.extra.extEliminar.forEach((invalidId) => {
                if (invalidId == extra.extId) {
                    invalid = true;
                }
            });
        }
        if (itemTemp.extra.extGrupo != null) {
            if (
                extra.extra.extGrupo === itemTemp.extra.extGrupo &&
                itemTemp.extId != extra.extId
            ) {
                invalid = true;
            }
        }
        return !invalid;
    }

    export const setStreamingFlagsByVelocity = (plan, category) => {
        if (
            (plan.vel === 60 || plan.vel === 80) &&
            category === 'residencial'
        ) {
            plan = {
                ...plan,
                isHBO: false,
                activeCombo: false,
                isNetflix: true,
            };
        } else {
            if (plan.isNetflix === undefined)
                plan = { ...plan, isNetflix: false };
            if (plan.vel === 60 && plan.isNetflix)
                plan = { ...plan, isHBO: false, activeCombo: false };
            if (plan.vel === 60 && !plan.isNetflix)
                plan = { ...plan, isHBO: true, activeCombo: false };
            if (plan.vel === 80 && plan.isNetflix)
                plan = { ...plan, isHBO: false, activeCombo: false };
            if (plan.vel === 80 && !plan.isNetflix)
                plan = { ...plan, isHBO: true, activeCombo: false };
            if (plan.vel === 150)
                plan = {
                    ...plan,
                    isNetflix: true,
                    isHBO: false,
                    activeCombo: true,
                };
            if (plan.vel >= 200)
                plan = {
                    ...plan,
                    isNetflix: true,
                    isHBO: false,
                    activeCombo: true,
                };
        }
        return plan;
    };
</script>
